import { render, staticRenderFns } from "./OnlineBooking.vue?vue&type=template&id=24986d6c&"
import script from "./OnlineBooking.vue?vue&type=script&lang=js&"
export * from "./OnlineBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports